$(function () {
  // メルカリShops カテゴリ/ブランドを AJAX 検索する select2 の初期化
  $('.mercari-remote-select').each(function () {
    const $el = $(this);
    const placeholder = $el.data('placeholder') || '検索';
    $el.select2({
      ajax: {
        url: $el.data('ajax-url'),
        dataType: 'json',
        delay: 250,
        data: (params) => ({ q: params.term || '', page: params.page || 1 }),
        processResults: (data, params) => {
          params.page = params.page || 1;
          return { results: data.results, pagination: data.pagination };
        }
      },
      placeholder: placeholder,
      allowClear: true,
      minimumInputLength: 0,
      width: '100%',
      language: {
        noResults: () => '該当なし',
        searching: () => '検索中...'
      }
    });

    $el.on('select2:open', function () {
      setTimeout(() => $('.select2-container--open .select2-search__field')[0]?.focus(), 300);
    });
  });

  const $container = $('#resale_listing_stocks');
  const $select = $('#candidate_stock_select');

  if ($container.length === 0) return;

  const updatePositions = () => {
    $container.find('[data-stock-row]').each(function (index) {
      $(this).find('[data-stock-position]').text(index + 1);
    });
  };

  $(document).on('click', '[data-resale-action]', function () {
    const action = $(this).data('resaleAction');
    const $row = $(this).closest('[data-stock-row]');

    if (action === 'move-up') {
      const $prev = $row.prev();
      if ($prev.length) { $row.insertBefore($prev); updatePositions(); }
    }

    if (action === 'move-down') {
      const $next = $row.next();
      if ($next.length) { $row.insertAfter($next); updatePositions(); }
    }

    if (action === 'remove-stock') {
      const stockId = $row.data('stockId');
      $row.remove();
      updatePositions();
      $select.find(`option[value="${stockId}"]`).prop('hidden', false);
      $select.selectpicker('refresh');
    }

    if (action === 'add-stock') {
      if ($select.length === 0 || !$select.val()) return;
      const $btn = $(this);
      $btn.prop('disabled', true);
      $.ajax({
        url: $select.data('rowUrl'),
        data: { stock_id: $select.val(), position: $container.find('[data-stock-row]').length + 1 },
        dataType: 'script',
      }).done(() => {
        $select.val('');
        $select.selectpicker('refresh');
      }).always(() => $btn.prop('disabled', false));
    }
  });

  const $mercariCheckbox = $('#mercari_enabled');
  const $mercariField = $('#mercari_field');
  const $kauriru2ndCheckbox = $('#kauriru2nd_enabled');
  const $kauriru2ndField = $('#kauriru2nd_field');

  const toggleField = ($checkbox, $field) => {
    if ($checkbox.length === 0 || $field.length === 0) return;
    $field.toggleClass('show', $checkbox.is(':checked'));
  };

  $mercariCheckbox.on('change', () => toggleField($mercariCheckbox, $mercariField));
  $kauriru2ndCheckbox.on('change', () => toggleField($kauriru2ndCheckbox, $kauriru2ndField));

  // アイテム属性・コンディションその他の追加/削除
  const updateRemoveButtons = ($c) => {
    const $pairs = $c.find('.key-value-pair');
    $pairs.find('.remove-pair').toggle($pairs.length > 1);
  };

  $(document).on('click', '.add-pair', function () {
    const $c = $($(this).data('target'));
    const isAttributes = $c.attr('id') === 'kauriru2nd_attributes_container';
    const paramName = isAttributes ? 'attributes' : 'other_conditions';
    const placeholder = isAttributes ? '属性名' : '条件名';
    $c.append($(`
      <div class="key-value-pair">
        <div class="row">
          <div class="col-md-5">
            <input type="text" name="resale_listing[shop_kauriru2nd][${paramName}][][key]" class="form-control key-input" placeholder="${placeholder}">
          </div>
          <div class="col-md-5">
            <input type="text" name="resale_listing[shop_kauriru2nd][${paramName}][][value]" class="form-control value-input" placeholder="値">
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-danger btn-sm remove-pair">✕</button>
          </div>
        </div>
      </div>
    `));
    updateRemoveButtons($c);
  });

  $(document).on('click', '.remove-pair', function () {
    const $c = $(this).closest('.key-value-container');
    $(this).closest('.key-value-pair').remove();
    updateRemoveButtons($c);
  });

  updateRemoveButtons($('#kauriru2nd_attributes_container'));
  updateRemoveButtons($('#kauriru2nd_other_conditions_container'));
});
